<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <div class="title my-3 d-block d-lg-none" id="purchaseSummary">
      <div class="d-md-inline-block">
        Venda: <b v-if="entry.totalPrice" class="green--text mr-md-4 float-right ml-md-3"> {{entry.totalPrice | formatCurrency}} </b> <b v-else class="black--text mr-4 float-right ml-md-3">R$ 0,00</b>
      </div>
      <div class="d-md-inline-block">
        Recebimentos: <b v-if="entry.totalPrice" :class="'float-right ml-md-3 ' + (entry.totalPrice == saleTotalPayment ? 'green--text' : 'red--text')"> {{saleTotalPayment | formatCurrency}} </b> <b v-else class="black--text mr-4 float-right ml-md-3">R$ 0,00</b>
      </div>
    </div>

    <v-tabs>
      <v-tab>Geral</v-tab>
      <v-tab v-if="entry.fiscalDocumentType != 'NFCe'">Entrega/Frete</v-tab>
      <v-tab>Recebimentos</v-tab>

      <v-spacer></v-spacer>
      <div class="title mt-3 d-none d-lg-block" id="saleSummary">
        Total da Venda: <b v-if="entry.totalPrice" class="green--text mr-4"> {{entry.totalPrice | formatCurrency}} </b> <b v-else class="black--text mr-4">R$ 0,00</b>
        Total de Recebimentos: <b v-if="entry.totalPrice" :class="entry.totalPrice == saleTotalPayment ? 'green--text' : 'red--text' "> {{saleTotalPayment | formatCurrency}} </b> <b v-else class="black--text mr-4">R$ 0,00</b>
      </div>


      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="3">
            <MaskedTextField
              v-bind="getObject('code')"
              :inputData.sync="entry.code"
              mask-type="integer"
              label="Código"
              readonly
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="9">
            <v-autocomplete
              v-model="entry.customerId"
              v-bind="getObject('customerId')"
              label="Cliente"
              :items="extraData.accountContext.allCustomers"
              item-value="id"
              item-text="name"
              :disabled="readOnly"
              autocomplete="off"
              clearable
              @click:clear="$nextTick(() => entry.customerId = null)"
            >
              <template v-slot:append-outer>
                <PersonNew
                  :inlineAddButton="true"
                  :isCustomer="true"
                  @entry-created="personCreated"
                  modelNameSingular="Pessoa"
                />
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              v-model="entry.cfopId"
              v-bind="getObject('cfopId')"
              label="Cfop"
              :items="extraData.accountContext.allCfops"
              item-value="id"
              item-text="text"
              :disabled="readOnly"
              autocomplete="off"
            >
            </v-autocomplete>
          </v-col>

          
            <v-col cols="12" sm="12" md="8" v-if="extraData.accountContext.accountPermissions.isAltavenda">
              <v-autocomplete v-model="entry.paymentConditionRuleId" v-bind="getObject('paymentConditionRuleId')" label="Condição de pagamento"
                :items="extraData.accountContext.allPaymentConditionRules" item-value="id" item-text="name" :disabled="readOnly"
                autocomplete="off" clearable @click:clear="$nextTick(() => entry.paymentConditionRuleId = null)">
              </v-autocomplete>
            </v-col>
          

          <v-col cols="12" sm="6" md="4">
            <DateField
              :inputData.sync="entry.date"
              v-bind="getObject('date')"
              label="Data da Venda"
              :hasTodayButton="true"
              :hasTodayDate="true"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" v-if="$can('update', 'OutboundNfce')">
            <v-radio-group
              v-model="entry.fiscalDocumentType"
              v-bind="getObject('fiscalDocumentType')"
              @change="fiscalDocumentTypeChanged"
              :disabled="readOnly">
              <template v-slot:label>
                <div> Tipo do <b>documento fiscal</b> que será emitido nesta venda: </div>
              </template> 
              <v-layout align-start row>
                <v-radio class="ml-4" label="Nota Fiscal do Produtor Eletrônica (NFP-e)" :value="'NFPe'"></v-radio>
                <v-radio class="ml-4" label="Nota Fiscal do Consumidor Eletrônica (NFC-e)" :value="'NFCe'"></v-radio>
              </v-layout>
            </v-radio-group>
          </v-col>

          <!-- <v-col cols="3">
            <DateField
              :inputData.sync="entry.orderValidity"
              v-bind="getObject('orderValidity')"
              label="Data de Validade"
              :hasTodayButton="true"
              :disabled="readOnly"
            />
          </v-col> -->
        </v-row>

        <v-row>
          <v-col cols="12" class="">
            <SaleProductIndex
              :saleProducts="entry.dummyExitMovementItemsAttributes"
              :saleTotalPrice.sync="productsTotalPrice"
              :readOnly="readOnly"
              :hasTableTitle="true"
              tableTitle="Produtos de Venda"
              :extras="extras"
            />
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
              v-bind="getObject('totalInsuranceValue')"
              :inputData.sync="entry.totalInsuranceValue"
              mask-type="currency"
              label="Seguro"
              prefix="R$"
              persistent-hint
              :disabled="readOnly"
              autocomplete="off"
            >
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
              v-bind="getObject('otherExpensesTotalValue')"
              :inputData.sync="entry.otherExpensesTotalValue"
              mask-type="currency"
              label="Outras Despesas"
              prefix="R$"
              persistent-hint
              :disabled="readOnly"
              autocomplete="off"
            >
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
              v-bind="getObject('totalCarriageValue')"
              :inputData.sync="entry.totalCarriageValue"
              mask-type="currency"
              label="Frete"
              prefix="R$"
              persistent-hint
              :disabled="readOnly"
              :key="totalCarriageValueKey"
              @change="totalCarriageValueKey += 1"
              autocomplete="off"
            >
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
              v-bind="getObject('totalDiscountValue')"
              :inputData.sync="entry.totalDiscountValue"
              mask-type="currency"
              label="Desconto"
              prefix="R$"
              persistent-hint
              :disabled="readOnly"
              autocomplete="off"
              :key="totalDiscountValueKey"
            >
              <template slot="prependMask">
                <v-icon>mdi-minus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <div class="title mt-3">
              <v-icon>mdi-equal</v-icon>
              Total da Venda: 
              <b class="headline black--text font-weight-bold ml-2"> {{saleTotalPrice | formatCurrency}} </b> 
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <DateField
              :inputData.sync="entry.estimatedDeliveryDate"
              v-bind="getObject('estimatedDeliveryDate')"
              label="Data Estimada de Entrega"
              :hasTodayButton="true"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12">
            <v-textarea
              v-model="entry.observation"
              v-bind="getObject('observation')"
              label="Observações"
              outlined
              :disabled="readOnly"
              autocomplete="off"
            ></v-textarea>
          </v-col>

        </v-row>
      </v-tab-item>

      <v-tab-item v-if="entry.fiscalDocumentType != 'NFCe'">
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="entry.carriageModalityId"
              v-bind="getObject('carriageModalityId')"
              label="Modalidade do Frete"
              :items="extraData.globalContext.allCarriageModalities"
              item-value="id"
              item-text="text"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>

          

          <v-col cols="12" sm="6" md="3" v-if="false">
            <MaskedTextField
              v-bind="getObject('carrierLicensePlate')"
              :inputData.sync="entry.carrierLicensePlate"
              mask-type="plate"
              label="Placa"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3" v-if="false">
            <v-autocomplete
              v-model="entry.carrierLicensePlateStateId"
              v-bind="getObject('carrierLicensePlateStateId')"
              label="UF Placa"
              :items="extraData.globalContext.allStates"
              item-value="id"
              item-text="shortName"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <MaskedTextField
              v-bind="getObject('totalCarriageValue')"
              :inputData.sync="entry.totalCarriageValue"
              mask-type="currency"
              label="Valor do Frete"
              prefix="R$"
              persistent-hint
              :disabled="readOnly"
              :key="totalCarriageValueKey"
              @change="totalCarriageValueKey += 1"
              autocomplete="off"
            />
          </v-col>           

            <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
              <v-autocomplete
              v-model="entry.carrierId"
              v-bind="getObject('carrierId')"
              label="Transportadora"
              :items="extraData.accountContext.allCarriers"
              item-value="id"
              item-text="name"
              @input="loadTrailers"
              :disabled="readOnly"
              autocomplete="off"
              />
          </v-col>

          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
              <v-autocomplete
              v-model="entry.carrierAddressId"
              v-bind="getObject('carrierAddressId')"
              label="Endereço"
              :items="carrierAddresses"
              item-value="id"
              item-text="fullAddressWithCityState"              
              :disabled="readOnly"
              autocomplete="off"
              />
          </v-col>

          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
              <v-autocomplete
              v-model="entry.carrierStateInscription"
              v-bind="getObject('carrierStateInscription')"
              label="IE"
              :items="carrierStateInscriptions"
              item-value="stateInscription"
              item-text="stateInscription"
              :disabled="readOnly"
              autocomplete="off"
              />
          </v-col>

          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
              <v-autocomplete
              v-model="entry.carrierPatrimonyId"
              v-bind="getObject('carrierPatrimonyId')"
              label="Veículo"
              :items="vehicles"
              item-value="id"
              item-text="vehicleName"
              :disabled="readOnly"
              autocomplete="off"
              />
          </v-col>

          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
              <v-autocomplete
              v-model="entry.trailerId"
              v-bind="getObject('trailerId')"
              label="Reboque"
              :items="trailers"
              item-value="id"
              item-text="vehicleName"
              :disabled="readOnly"
              autocomplete="off"
              />
          </v-col>

          

          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
            <MaskedTextField
              v-bind="getObject('volume')"
              :inputData.sync="entry.volume"
              mask-type="currency"
              label="Quantidade"
              prefix=""
              persistent-hint
              :disabled="readOnly"                            
              autocomplete="off"
            />
          </v-col>       
          
          
          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
            <v-text-field
              v-model="entry.specie"
              v-bind="getObject('specie')"              
              label="Espécie"              
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>


          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
            <v-text-field
            v-model="entry.brand"
            v-bind="getObject('brand')"
            label="Marca"              
            :disabled="readOnly"
            autocomplete="off"
            >
          </v-text-field>
        </v-col>              

          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
            <MaskedTextField
              v-bind="getObject('grossWeight')"
              :inputData.sync="entry.grossWeight"
              mask-type="currency"
              label="Peso Bruto"
              prefix=""
              persistent-hint
              :disabled="readOnly"                            
              autocomplete="off"
              :key="grossWeightKey"
            />
          </v-col>          
          
          <v-col cols="12" sm="6" v-if="entry.carriageModalityId && entry.carriageModalityId != 6">
            <MaskedTextField
              v-bind="getObject('netWeight')"
              :inputData.sync="entry.netWeight"
              mask-type="currency"
              label="Peso Líquido"
              prefix=""
              persistent-hint
              :disabled="readOnly"                            
              autocomplete="off"
              :key="netWeightKey"
            />
          </v-col> 
                

        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" class="mt-3">
            <PaymentIndex
              :payments="entry.paymentsAttributes"
              :totalPayment.sync="saleTotalPayment"
              :paymentLimit="entry.totalPrice"
              :readOnly="readOnly"
              modelType="Sale"
              @installment-update="$emit('installment-update', $event)"
              :hasTableTitle="true"
              tableTitle="Recebimentos"
            />
          </v-col>
        </v-row>
      </v-tab-item>

    </v-tabs>
    
  </v-form>
</template>

<script>
import gql from 'graphql-tag';
import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import SaleProductIndex from "@models/sales/sale_products/index.vue"
import PaymentIndex from "@models/payments/index.vue"
import PersonNew from "@models/people/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      saleTotalPayment: 0,
      productsTotalPrice: 0,
      totalCarriageValueKey: 0,
      totalDiscountValueKey: 0,
      grossWeightKey: 0,
      netWeightKey: 0,
      pageLoading: false,
      trailers: [],
      vehicles: [],
      carrierAddresses: [],
      carrierStateInscriptions: [],
      extras: {},
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    SaleProductIndex: SaleProductIndex,
    DateField: DateField,
    PaymentIndex: PaymentIndex,
    PersonNew: PersonNew,
    BaseUtil: BaseUtil
  },
  created() {
    // console.log("extraData",this.extraData);
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    for (var payment in this.entry.paymentsAttributes) {
      if (this.entry.paymentsAttributes[payment] && this.entry.paymentsAttributes[payment].value && !this.entry.paymentsAttributes[payment]._destroy) {
        this.saleTotalPayment += this.entry.paymentsAttributes[payment].value;
      }
    }
    this.saleTotalPayment = _.round(this.saleTotalPayment, 2);    
    if (this.entry.totalPrice) {      
      this.productsTotalPrice = 0;
      for (var product in this.entry.dummyExitMovementItemsAttributes) {        
        if (this.entry.dummyExitMovementItemsAttributes[product] && this.entry.dummyExitMovementItemsAttributes[product].price && !this.entry.dummyExitMovementItemsAttributes[product]._destroy) {
          if(this.entry.dummyExitMovementItemsAttributes[product].lossQuantity){
            this.productsTotalPrice += this.entry.dummyExitMovementItemsAttributes[product].unitPrice * (this.entry.dummyExitMovementItemsAttributes[product].quantity - this.entry.dummyExitMovementItemsAttributes[product].lossQuantity);
          }else{
            this.productsTotalPrice += this.entry.dummyExitMovementItemsAttributes[product].price;
          }          
        }
      }
    }
    this.productsTotalPrice = _.round(this.productsTotalPrice, 2);

    this.fiscalDocumentTypeChanged();

    if(this.extras.accountContext){
      
    }else{
      this.extras.accountContext = {};
    }
    this.extras.accountContext.accountPermissions = this.extraData.accountContext.accountPermissions;

    if(this.entry.customerId){
      this.extras.customerId = this.entry.customerId;
    }

    if(this.entry.paymentConditionRuleId){
      this.extras.paymentConditionRuleId = this.entry.paymentConditionRuleId;
    }

    // if(this.entry.dummyExitMovementItemsAttributes){
    //   this.calculateWeights(this.entry.dummyExitMovementItemsAttributes);
    // }

    console.log("cre entry",this.entry);
  },
  mounted() {
    this.loadTrailers();
    if(this.entry.dummyExitMovementItemsAttributes){
      this.calculateWeights(this.entry.dummyExitMovementItemsAttributes);
    }
  },
  watch: {
    "entry.customerId": function(newValue, oldValue){
      this.extras.customerId = newValue;
      // console.log("extras form", this.extras);
    },
    "entry.paymentConditionRuleId": function(newValue, oldValue){
      this.extras.paymentConditionRuleId = newValue;
    },
    "entry.dummyExitMovementItemsAttributes": {
      handler: function (newValue, oldValue) {
        // console.log("dummies");
        //todo carregar informacoes dos storages novamente !!! ver se precisa!!!
        var total_discount = newValue.reduce( (accumulator, obj)=> accumulator + (obj.discount * obj.packagingQuantity),0 );
        // console.log(total_discount);
        this.entry.totalDiscountValue = total_discount;

        this.calculateWeights(newValue);


        this.totalDiscountValueKey++;
      },
      deep: true,
    },
  },
  computed: {
    saleTotalPrice: function() {
      this.productsTotalPrice = this.productsTotalPrice ? this.productsTotalPrice : 0;
      this.entry.totalInsuranceValue = this.entry.totalInsuranceValue ? this.entry.totalInsuranceValue : 0; 
      this.entry.otherExpensesTotalValue = this.entry.otherExpensesTotalValue ? this.entry.otherExpensesTotalValue : 0;
      this.entry.totalCarriageValue = this.entry.totalCarriageValue ? this.entry.totalCarriageValue : 0;
      this.entry.totalDiscountValue = this.entry.totalDiscountValue ? this.entry.totalDiscountValue : 0;

      return this.entry.totalPrice = this.productsTotalPrice 
                                     + this.entry.totalInsuranceValue 
                                     + this.entry.otherExpensesTotalValue
                                     + this.entry.totalCarriageValue
                                     - this.entry.totalDiscountValue;
    }
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    calculateWeights: function(newValue){
      
      try{
          // console.log("pesos");
          var current = null;
          // var gross_weight = newValue.reduce( (accumulator, obj)=> accumulator + (obj.itemWeight.grossWeight * obj.packagingQuantity),0 );
          var gross_weight = 0;
          newValue.forEach( (obj) => {
            current = obj;
            gross_weight+= accumulator + (obj.itemWeight.grossWeight * obj.packagingQuantity)
          });
            
          this.entry.grossWeight = gross_weight;
          // console.log(gross_weight);

          var liquid_weight = newValue.reduce( (accumulator, obj)=> accumulator + (obj.itemWeight.liquidWeight * obj.packagingQuantity),0 );
          // console.log(liquid_weight);
          this.entry.netWeight = liquid_weight;

        }catch(e){
          //console.log("exc", newValue, this.$refs, this.$refs.util, this.$can('access', 'Altavenda'));
          if (this.$can('access', 'Altavenda')){
            //this.$refs.util.showErrorMessage("Algum item não possui o peso configurado, não foi possível calcular os pesos totais (bruto e líquido) automaticamente");
          }
          // console.log("catch", this.entry);
          // this.entry.netWeight = null;
          // this.entry.grossWeight = null;
        }
        this.netWeightKey++;
        this.grossWeightKey++;
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    personCreated: function(person) {
      //testar pra ver se o tipo é supplier
      if (person.isCustomer) {
        this.extraData.accountContext.allCustomers.unshift(person);
        this.entry.customerId = person.id;
        this.entry.customer = person;
      } else {
        this.$refs.util.showErrorMessage("A pessoa cadastrada não é do tipo Cliente, por isso não irá aparecer na lista de clientes!");
      }
    },
    fiscalDocumentTypeChanged: function() {
      this.entryAttributes.customerId.rules = [];
      this.entryAttributes.carriageModalityId.rules = [];
      if (this.entry.fiscalDocumentType != "NFCe") {
        this.entryAttributes.customerId.rules.push(this.requiredRule);
        this.entryAttributes.carriageModalityId.rules.push(this.requiredRule);
      }
      this.clearFields();
    },
    clearFields: function() {
      this.forceRerender(this);
    },

    loadTrailers: function() {
      if(this.entry.carrierId){
        this.error = null;
        this.loading = true;      
          this.$apollo
            .query({
              query: LOAD_CARRIER_DATA,
              variables:{
                carrierId: this.entry.carrierId
              },
              fetchPolicy: "no-cache"
            })
            .then(response => {
              // console.log("resposta", response.data);
              this.trailers = response.data.accountContext.allTransportTrailers;
              this.vehicles = response.data.accountContext.allTransportVehicles;
              this.carrierAddresses = response.data.accountContext.allCarrierAddresses;
              this.carrierStateInscriptions = response.data.accountContext.allCarrierIes;
              if(this.carrierStateInscriptions.length == 1){
                this.entry.carrierStateInscription = this.carrierStateInscriptions[0].stateInscription;
              }
              // this.extraData = response.data;
            })
            .catch(response => console.log(response))
            .finally(() => (this.loading = false));
      }
    },
  }
};



const LOAD_CARRIER_DATA = gql `
  query ($carrierId: ID!) {
    accountContext {
      allCarrierTrailers(carrierId: $carrierId) {
        id
        vehicleName
        description
      }
      allTransportVehicles{
        id
        vehicleName
        description
      }
      allTransportTrailers{
        id
        vehicleName
        description
      }
      allCarrierVehicles(carrierId: $carrierId){
        id
        vehicleName
        description
      }
      allCarrierAddresses(carrierId: $carrierId){
        id
        fullAddressWithCityState
      }
      allCarrierIes(carrierId: $carrierId){
        id
        stateInscription
      }
    }
  }
`;


</script>

<style scoped>
  #saleSummary {
    color: gray;
  }
</style>
